import { useLanguage } from "@/contexts/LanguageContext";
import { ScrollReveal } from "@/components/ScrollReveal";

export function PainSection() {
  const { t } = useLanguage();

  const statements = [t("pain.1"), t("pain.2"), t("pain.3") + "\n" + t("pain.4")];

  return (
    <section className="py-32 md:py-40 px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="max-w-4xl space-y-8 md:space-y-12">
          {statements.map((s, i) => (
            <ScrollReveal key={i} delay={i * 150}>
              <p className="font-display text-display-md whitespace-pre-line">{s}</p>
            </ScrollReveal>
          ))}
        </div>
        <ScrollReveal delay={500}>
          <p className="mt-16 text-body-lg text-muted-foreground max-w-2xl leading-relaxed">
            {t("pain.bridge")}
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
